import { IState } from 'src/app/shared/interfaces/state.interfaces';
import { Injectable } from '@angular/core';
import * as allStates from 'src/assets/states.json';
import { groupBy } from '@progress/kendo-data-query';

const STATE_TYPE_ORDER: Record<string, number> = {
  'US States': 1,
  'US Territories': 2,
  'Canadian Provinces': 3,
};

@Injectable({
  providedIn: 'root'
})

export class StateService {
  public get allStates(): IState[] {
    return ((allStates as any).default as IState[]).slice().sort(
      (a, b) => (STATE_TYPE_ORDER[a.type] ?? 99) - (STATE_TYPE_ORDER[b.type] ?? 99)
    );
  }

  /** Returns states grouped by type (US States → US Territories → Canadian Provinces) */
  public groupedStates(states: IState[]): any[] {
    return (groupBy(states, [{ field: 'type' }]) as any[])
      .sort((a, b) => (STATE_TYPE_ORDER[a.value] ?? 99) - (STATE_TYPE_ORDER[b.value] ?? 99));
  }
}
